var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.690997 8.18002L0.02433 11.52C-0.05567 11.9067 0.06433 12.3 0.34433 12.5734C0.56433 12.7934 0.86433 12.9134 1.171 12.9134C1.24433 12.9134 1.32433 12.9067 1.39766 12.8934L4.73766 12.2267C4.791 12.2134 4.84433 12.2 4.89766 12.18L0.730997 8.02002C0.717663 8.07335 0.697663 8.12669 0.68433 8.18002H0.690997Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.984 0.926666C11.384 0.326667 10.5907 0 9.74401 0C8.89734 0 8.10401 0.326667 7.50401 0.926666L1.27734 7.15333L5.75734 11.6333L11.984 5.40667C12.584 4.80667 12.9107 4.01333 12.9107 3.16667C12.9107 2.32 12.584 1.52667 11.984 0.926666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.6fb2b5c97c1c0133dce2c1afb7df840e.svg";
export { ForwardRef as ReactComponent };